import { Box, Button, chakra, Flex, HStack, Input, Spinner } from '@chakra-ui/react';
import { AddIcon, HamburgerIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../stores/pipeline-store';
import useRuntimeStore from '../../stores/runtime-store';
import { useCallback } from 'react';
import { AiOutlineBug } from 'react-icons/ai';

const CFFaBug = chakra(AiOutlineBug);

const Header: React.FC = ({}) => {
    const { pipeline, setPipeline, updatePipeline } = usePipelineStore((state: any) => state);

    const { isSyncing, setVarsModalIsOpen, setDebugModalIsOpen, pageDelta } = useRuntimeStore((state: any) => state);
    const createStep = useCallback(() => {
        let stepId = '';
        while (!stepId) {
            const randId = Math.random().toString(36).slice(2, 17);
            if (Object.keys(pipeline.steps).indexOf(randId) < 0) {
                stepId = randId;
            }
        }
        let newStep: PipelineStep = {
            type: 'EMPTY',
            name: '',
            description: '',
            editorSettings: {
                collapseSettings: true,
                collapseTransitions: true,
                collapseLogs: true,
                collapseAnalytics: false,
                color: 'black',
                position: {
                    x: pageDelta.x + Math.floor(Math.random() * 300),
                    y: pageDelta.y + Math.floor(Math.random() * 300),
                },
                size: { height: 0, width: 0 },
                zIndex: 10000,
            },
            analyticsSettings: {
                sendEvent: false,
                eventName: '',
                distinctId: '',
                payload: [],
            },
            logsMsgs: [],
            transitions: [],
        };
        let newPipeline = JSON.parse(JSON.stringify(pipeline));
        newPipeline.steps[stepId] = newStep;
        newPipeline.editorSettings.stepIds.push(stepId);
        if (!pipeline.firstStepId) {
            newPipeline.firstStepId = stepId;
        }
        setPipeline(newPipeline);
    }, [pipeline, setPipeline, pageDelta]);
    return (
        <Box bgColor={'lightblue'}>
            <Flex h={10} alignItems={'center'} justifyContent={'space-between'} px={2} borderBottom={'1px'}>
                <HStack>
                    {isSyncing && <Spinner size={'xs'} ml={1} mr={-3} thickness={'1px'} />}
                    <Input
                        value={pipeline.name}
                        // textAlign={"center"}
                        border={'none'}
                        focusBorderColor={'none'}
                        onChange={({ target: { value } }: any) => {
                            updatePipeline('name', value);
                        }}
                    />
                </HStack>
                <Flex my={4}>
                    <Button
                        variant={'outline'}
                        colorScheme={'black'}
                        size={'sm'}
                        // mx={3}
                        leftIcon={<CFFaBug />}
                        onClick={() => {
                            setDebugModalIsOpen(true);
                        }}
                    >
                        Debug
                    </Button>
                    <Button
                        variant={'outline'}
                        colorScheme={'black'}
                        size={'sm'}
                        mx={3}
                        leftIcon={<HamburgerIcon />}
                        onClick={() => {
                            setVarsModalIsOpen(true);
                        }}
                    >
                        Vars
                    </Button>
                    <Button
                        variant={'solid'}
                        colorScheme={'teal'}
                        size={'sm'}
                        leftIcon={<AddIcon />}
                        onClick={createStep}
                    >
                        Step
                    </Button>
                </Flex>
            </Flex>
        </Box>
    );
};

export default Header;
